var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vPage',[_c('vBookHeader',{attrs:{"name":"Ihme ilmat puuhakirja","title":"Koko perheen puuhakirja","ingress":"Tehtäviä, jotka auttavat ymmärtämään maailman muutosta ja muuttamaan maailmaa.","coAuthor":"Kuvittaja Mari Ahokoivu","publisher":"Into Kustannus","published":"2021","flag":"Tulossa"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-786c3c7e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/books/IhmeIlmatPuuha.vue
// module id = null
// module chunks = 